__turbopack_context__.v({
  "container": "ySiRPW_container",
  "mapDetails": "ySiRPW_mapDetails",
  "mapImage": "ySiRPW_mapImage",
  "openButton": "ySiRPW_openButton",
  "overlayButton": "ySiRPW_overlayButton" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "sheetContent": "ySiRPW_sheetContent",
});
